export const urls = {
  HOME: 'home',
  EPISODES: 'episodes',
  ABOUT: 'about',
}

export const AUTHOR = '/author';
